module.exports = __webpack_public_path__ + "f495da0e225b5eab274f6275aab132e0.MP3";